import { render, staticRenderFns } from "./PendingIncome.vue?vue&type=template&id=72df68ec&scoped=true"
import script from "./PendingIncome.vue?vue&type=script&lang=js"
export * from "./PendingIncome.vue?vue&type=script&lang=js"
import style0 from "./PendingIncome.vue?vue&type=style&index=0&id=72df68ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72df68ec",
  null
  
)

export default component.exports